import { CalendarHeaderContext, CalendarHeaderContextType } from '../../../../context/calendar-header-context';
import { CalendarHeaderContainer } from './container';

export const CalendarHeader = (props: CalendarHeaderContextType) => (
  <CalendarHeaderContext.Provider value={props}>
    <CalendarHeaderContainer />
  </CalendarHeaderContext.Provider>
);
